import "./GestionUsuarios.css";
import { sendAjaxRequest } from "@/ts/api/comunicacion";
import type { Usuario } from "@/ts/typings/clases";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { TablaUsuarios } from "./TablaUsuarios";
import { ModalEditarUsuario } from "./components/ModalEditarUsuario";
import { Breadcrumb } from "@/components/Breadcrumb";

export function GestionUsuariosPage() {
	const [modalNewUser, setModalNewUser] = useState(false);

	return (
		<div id="content" className="content" >
			<title>Piher | Listado de usuarios</title>

			<Breadcrumb
				sectionTitle="Listado de Usuarios"
				links={[
					{ label: "Listado de Usuarios", active: true }
				]}
			/>


			<button onClick={() => { setModalNewUser(true); }} type="submit" className="btnPrimary" style={{ width: "max-content" }}>
				Nuevo usuario
			</button>
			<div>
				<TablaUsuarios />
			</div>
			<ModalEditarUsuario shown={modalNewUser} close={() => { setModalNewUser(false); }} usuario={null} />
		</div>
	);
}

export function useUsuarios() {
	return useQuery<Usuario[]>({
		queryKey: ["getListadoUsuarios"],
		queryFn: () => {
			const url = "/api/v1/getListadoUsuarios";
			return sendAjaxRequest<Usuario[]>("GET", url, {});
		},
	});
}